import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const SearchResults = lazy(
  () =>
    import('./SearchResults.eager').then(mod => ({
      default: mod.SearchResults,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
